{
  "entity": {
    "announcement": "an announcement",
    "api_key": "a key for other apps",
    "attribute_definition": "an extra product detail",
    "audit_log": "the change history",
    "background_job": "a background task",
    "bank_import_batch": "a bank file",
    "bank_import_line": "a bank file line",
    "brand": "a brand",
    "bulk_job": "a bulk change",
    "buylist_intake": "a buy-in (買取)",
    "card": "a card",
    "card_set": "a card set",
    "carrier": "a delivery company",
    "cash_movement": "cash in / out",
    "category": "a category",
    "collection": "a collection",
    "condition_export_map": "the condition list for marketplaces",
    "consignment_intake": "a consignment intake",
    "consignment_item": "a consigned card",
    "consignment_report": "a consignment report",
    "consignment_return": "a return to a consignor",
    "consignment_sale": "a consignment sale",
    "consignor": "a consignor",
    "customer": "a customer",
    "dead_letter": "an update that could not be delivered",
    "discount": "a discount code",
    "document": "a document",
    "document_export_job": "a document download",
    "dsar": "a personal data request",
    "dsar_request": "a personal data request",
    "edc_settlement_batch": "a card terminal statement",
    "edc_statement_line": "a card terminal statement line",
    "event": "a system update",
    "export_evidence": "export proof",
    "export_job": "a download",
    "facet_config": "the search filters",
    "fx_rate": "an exchange rate",
    "game": "a card game",
    "identity_check": "an ID check (本人確認)",
    "import_job": "a file import",
    "inbox_item": "a to-do",
    "inventory_item": "a stock item",
    "kobutsu_export": "a 古物台帳 download",
    "kobutsu_ledger": "the 古物台帳",
    "label_job": "a label print",
    "legal_calendar": "the legal calendar",
    "localization": "the website languages",
    "mail_settings": "the e-mail sending",
    "market": "a country group",
    "media_asset": "a picture",
    "media_folder": "a picture folder",
    "media_item": "a picture",
    "media_tag": "a picture tag",
    "menu": "a website menu",
    "not_found_hit": "a missing web address",
    "notification": "an e-mail",
    "notification_preference": "e-mail choices",
    "notification_setting": "the notification settings",
    "notification_template": "an e-mail text",
    "offline_batch": "register sales made offline",
    "offline_op": "a register action made offline",
    "order": "an order",
    "order_export": "an order download",
    "order_line": "an order line",
    "order_setting": "the order settings",
    "oversell_conflict": "a card sold twice",
    "page": "a website page",
    "payment": "a payment",
    "payment_export": "a payment download",
    "payment_method_config": "a way to pay",
    "payments_ledger": "the payment book",
    "payout": "a consignor payment",
    "payout_batch": "a consignor payment batch",
    "policy": "a shop rules page",
    "pos_cart": "a register basket",
    "pos_device": "a register",
    "pos_hold": "a sale on hold",
    "pos_sale": "a register sale",
    "pos_setting": "the register rules",
    "product": "a product",
    "receipt": "a receipt",
    "redirect": "an old web address",
    "redirect_import": "old web addresses from a file",
    "refund": "a refund",
    "register": "a register",
    "reservation": "a reserved card",
    "revalidation": "a website refresh",
    "role": "a role",
    "saved_view": "a saved list view",
    "search_index": "the website search",
    "search_settings": "the search settings",
    "section_group": "a part of the website design",
    "section_manifest": "the website design parts",
    "security_incident": "a security incident",
    "service": "a part of the system",
    "shift": "a register shift",
    "shipping_rate": "a way to ship",
    "shipping_zone": "a shipping area",
    "signing_key": "a security key",
    "staff": "a staff member",
    "staff_user": "a staff member",
    "stock_discrepancy": "a stock difference",
    "store_credit_ledger": "store credit",
    "store_credit_lot": "store credit",
    "store_credit_snapshot": "store credit",
    "synonym_set": "search words",
    "tax": "tax",
    "tax_calculation": "a tax calculation",
    "tax_free_customs_import": "a customs file (免税)",
    "tax_free_export_batch": "a tax-free file for the tax office",
    "tax_free_passport": "a passport (免税)",
    "tax_free_record": "a tax-free sale",
    "tax_free_verification": "a tax-free check",
    "tax_setting": "the tax settings",
    "taxfree_record": "a tax-free sale",
    "template": "a page layout",
    "theme": "the website design",
    "translation": "a translation",
    "translations": "translations",
    "ui_strings": "website texts",
    "variant": "an item for sale",
    "webhook_endpoint": "a connection to another app",
    "retention_job": "Automatic clean-up (kept only as long as needed)"
  },
  "entity_other": "a record",
  "audit": {
    "title": "Change history",
    "intro": "Who did what, and when. Open a line to see exactly what changed.",
    "default_range": "Shows the last {{days}} days unless you choose dates.",
    "time": "When",
    "who": "Who",
    "what": "What happened",
    "record": "Record",
    "ip": "From address",
    "filter_record": "Kind of record",
    "filter_who": "Staff member",
    "filter_kind_of_who": "Done by",
    "filter_area": "Part of the shop",
    "filter_dates": "Dates",
    "filter_id": "Record number",
    "actor": {
      "staff": "Staff",
      "customer": "Customer",
      "system": "The system",
      "service": "The system",
      "api_key": "Another app",
      "pos": "Register"
    },
    "area": {
      "catalog": "Products",
      "inventory": "Stock",
      "orders": "Orders",
      "payments": "Payments",
      "pos": "Register",
      "consignment": "Consignment",
      "tax": "Tax",
      "cms": "Website",
      "identity": "Staff and sign-in",
      "notification": "Notifications",
      "media": "Pictures and documents",
      "search": "Website search"
    },
    "verb": {
      "created": "Created {{what}}",
      "updated": "Changed {{what}}",
      "deleted": "Removed {{what}}",
      "status": "Changed the status of {{what}}",
      "viewed": "Looked at or downloaded {{what}}",
      "signin": "Sign-in / security: {{what}}",
      "price": "Changed the price of {{what}}",
      "price_from_to": "Changed the price of {{what}} {{from}} → {{to}}"
    },
    "open_record": "Open the record",
    "no_fields": "No field details were kept for this change.",
    "technical_hidden": "{{count}} system detail(s) also changed (not shown).",
    "field": "Field",
    "before": "Before",
    "after": "After",
    "hidden": "hidden",
    "export_failed": "The file could not be made. Try a shorter date range.",
    "fields": {
      "price": "Price",
      "compareAtPrice": "Price before discount",
      "status": "Status",
      "title": "Title",
      "name": "Name",
      "email": "E-mail",
      "phone": "Phone",
      "address": "Address",
      "note": "Note",
      "quantity": "Quantity",
      "rawRank": "Rank",
      "permissions": "What they may do",
      "roleId": "Role",
      "active": "Active",
      "tags": "Tags",
      "fee": "Fee",
      "feePercent": "Fee %",
      "amount": "Amount"
    }
  },
  "jobs": {
    "title": "Background tasks and backups",
    "intro": "Work the system does by itself: is it running, did something fail, when was the last backup.",
    "problems_title": "Problems with background work",
    "problems_count_one": "{{count}} open",
    "problems_count_other": "{{count}} open",
    "problems_none": "None",
    "to_inbox": "Open the problems in the to-do list",
    "scheduled_title": "Scheduled tasks",
    "never": "never ran",
    "took": "took {{seconds}} s",
    "run_now": "Run now (今すぐ実行)",
    "started": "“{{name}}” started.",
    "run_failed": "The task could not be started.",
    "confirm_title": "Run “{{name}}” now?",
    "confirm_body": "It runs once now, in addition to its usual time.",
    "status": {
      "ok": "Finished",
      "failed": "Failed",
      "running": "Running",
      "never": "Not run yet",
      "queued": "Waiting to run",
      "stuck": "Stuck"
    },
    "names": {
      "all": {
        "purge_expired_plumbing": "Clean up old technical records"
      },
      "catalog": {
        "publish_scheduled": "Put scheduled products on sale",
        "purge_deleted_products": "Remove products deleted long ago",
        "purge_expired_exports": "Remove old download files",
        "recheck_compare_at": "Re-check “was” prices (景品表示法)",
        "refresh_smart_collections_all": "Update automatic collections",
        "retry_stalled_jobs": "Retry stuck imports and exports"
      },
      "cms": {
        "announcement_schedule": "Show / hide scheduled announcements",
        "backup_content": "Back up the website content",
        "cms_housekeeping": "Tidy up old website drafts",
        "media_usage_refresh": "Recount where pictures are used",
        "publish_scheduled_pages": "Publish scheduled pages",
        "scheduled_publish": "Publish scheduled website changes"
      },
      "consignment": {
        "consignment_expiry": "Consignment periods that end",
        "consignment_items_closer": "Close finished consignment items",
        "consignment_stage_gauge": "Count consignment items per step",
        "identity_retention_purge": "Delete ID copies past their keeping time",
        "intake_documents_sweeper": "Finish intake papers",
        "items_catalog_sweeper": "Link consignment items to products",
        "kobutsu_completeness_check": "Check the 古物台帳 for missing details",
        "kobutsu_retention_report": "Monthly 古物台帳 keeping report",
        "payout_schedule": "Prepare consignor payouts",
        "payout_statement_sweeper": "Make payout statements",
        "price_proposals_sweeper": "Close unanswered price proposals",
        "returns_sweeper": "Follow up returns to consignors",
        "settlements_sweeper": "Settle sold consignment items"
      },
      "identity": {
        "audit_maintenance": "Seal and store the change history",
        "dsar_follow_up": "Follow up data requests",
        "purge_expired_identity": "Remove expired sign-in links and codes"
      },
      "inventory": {
        "reconcile_ledger": "Check stock numbers"
      },
      "media": {
        "document_integrity": "Check stored documents are intact",
        "document_retention": "Delete documents past their keeping time",
        "expire_document_exports": "Remove old document downloads",
        "gc_orphans": "Remove unused uploads",
        "refresh_storage_bytes": "Recount storage used",
        "requeue_stuck_assets": "Retry pictures that got stuck",
        "restricted_retention": "Delete ID pictures past their keeping time",
        "retry_stuck_documents": "Retry receipts / PDFs that got stuck"
      },
      "notification": {
        "notification_tick": "Send reminders, summaries and waiting e-mails"
      },
      "orders": {
        "expire_carts": "Empty old shopping bags",
        "expire_checkouts": "Release unfinished checkouts",
        "expire_order_tokens": "End old order tracking links",
        "import_jp_postal": "Update Japanese postal codes",
        "remind_uncollected_pickups": "Remind about orders not picked up",
        "saga_compensate": "Undo checkouts whose payment failed"
      },
      "payments": {
        "expire_bank_transfers": "Cancel bank transfers not paid in time",
        "expire_store_credit": "End expired store credit",
        "payments_ledger_check": "Check payments against the ledger",
        "store_credit_kijunbi_snapshot": "Store credit balance on the 基準日 (資金決済法)"
      },
      "search": {
        "purge_search_query_log": "Remove old search words",
        "search_consistency_check": "Check the website search is complete",
        "search_recover_stalled": "Retry stuck search updates",
        "sync_collection_members": "Update collections in search"
      },
      "tax": {
        "calendar_alerts": "Tax / legal date reminders",
        "evidence_reminder": "Remind about missing export proof",
        "purge_pii": "Delete personal data past its keeping time",
        "refresh_fx": "Update exchange rates",
        "tax_reconcile": "Check tax records against orders",
        "taxfree_expire": "Close tax-free records after 90 days",
        "taxfree_transmit": "Send tax-free purchase records"
      },
      "realtime": {
        "purge_connection_audit": "Remove old live-update connection records"
      }
    },
    "next": "Next:",
    "already_waiting": "“{{name}}” is already waiting to run.",
    "already_running": "“{{name}}” is running right now — try again when it has finished.",
    "not_allowed": "This task cannot be started by hand.",
    "stuck_stopped": "It stopped halfway (the part that runs it was restarted). “Run now” starts it again.",
    "stuck_not_picked_up": "It has been waiting for a long time — the part that runs it may be stopped. Ask IT to check it.",
    "could_not_read": "The list of tasks could not be read just now. It tries again by itself.",
    "unreachable": "No answer from: {{parts}} — their tasks are missing below.",
    "not_connected_parts": "Not connected yet: {{parts}}.",
    "small_title_one": "{{count}} small task that runs every hour or more often",
    "small_title_other": "{{count}} small tasks that run every hour or more often"
  },
  "backups": {
    "title": "Backups",
    "last": "Last backup",
    "size": "Size",
    "where": "Stored at",
    "next": "Next backup",
    "kept": "Kept for",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "drill": "Last restore test",
    "drill_ok": "worked",
    "drill_failed": "failed",
    "never": "never",
    "plan": "Restoring is done by IT with the instructions ({{path}}) — there is no restore button here on purpose.",
    "state": {
      "ok": "Up to date",
      "too_old": "Older than {{hours}} hours",
      "never": "No backup found",
      "unreadable": "Status cannot be read"
    },
    "could_not_read": "The backup status could not be read just now. It tries again by itself.",
    "not_configured": "Backup status is not set up on this server yet. Backups run every night at {{time}} (Japan time) and are kept {{days}} days.",
    "unreadable": "The backup status file cannot be read — ask IT to check the backup storage.",
    "last_try_failed": "The last backup try failed:",
    "encrypted": "encrypted",
    "storage": {
      "online": "Online storage ({{name}})",
      "online_unnamed": "Online storage",
      "this_server": "Only on the server itself"
    }
  },
  "health": {
    "title": "Is everything running?",
    "all_ok": "Everything is running",
    "some_down_one": "{{count}} part has a problem",
    "some_down_other": "{{count}} parts have a problem",
    "ok": "Running",
    "no_answer": "No answer",
    "problem_with": "Problem: {{what}}",
    "build": "Admin version: {{release}}",
    "uptime": "Monitoring page",
    "errors": "Error reports",
    "check": {
      "database": "database",
      "nats": "messaging"
    },
    "service": {
      "identity": "Staff and sign-in",
      "catalog": "Products",
      "inventory": "Stock",
      "tax": "Tax",
      "orders": "Orders and shipping",
      "payments": "Payments",
      "pos": "Register",
      "consignment": "Consignment",
      "cms": "Website content",
      "media": "Pictures and documents",
      "search": "Website search",
      "notification": "E-mails and to-dos",
      "realtime": "Live updates"
    }
  },
  "features": {
    "title": "Features for later",
    "intro": "Connections to other platforms are built in later phases. They stay switched off until then.",
    "when": "They are switched on when the owner asks and that phase is finished — there is no switch here.",
    "error": "The switches could not be read just now — everything is shown as Off.",
    "on": "On",
    "off": "Off",
    "where": "Where it will appear",
    "names": {
      "payments__stripe": "Card payments on the website (Stripe)",
      "payments__stripe_connect": "Paying consignors by card service (Stripe)",
      "channels__ebay": "eBay",
      "channels__whatnot": "Whatnot",
      "channels__mercari": "Mercari",
      "channels__tiktok_shop": "TikTok Shop",
      "tax__nta_api": "Sending tax-free records to the tax office online",
      "shipping__shipandco": "Shipping labels (Ship&co)",
      "shipping__zonos": "Import duties at checkout (Zonos)"
    }
  },
  "refresh": {
    "title": "Website refresh",
    "intro": "After a change, the shop tells the website which parts to show new. Here you see whether that arrived, and can send it again.",
    "todo": "The website may not be updated yet",
    "todo_close": "Done (完了)",
    "todo_done": "To-do closed.",
    "manual_title": "Refresh a part of the website now",
    "manual_intro": "Use this when the website still shows old content.",
    "refresh_part": "Refresh: {{part}}",
    "part_sent": "Refresh of {{part}} sent.",
    "error": "The refresh history could not be loaded.",
    "empty": "No refreshes yet.",
    "not_configured": "The website connection is not set up — refreshes are not sent (IT).",
    "send_again": "Send again",
    "sent_again": "Sent again — it usually arrives within seconds.",
    "status": {
      "done": "Done",
      "retrying": "Trying again",
      "failed": "Not yet — still trying by itself",
      "stopped": "Stopped trying",
      "joined": "Sent with a later refresh",
      "waiting": "On its way",
      "off": "Switched off"
    },
    "parts": {
      "design": "website design",
      "page": "a page",
      "rules": "shop rules pages",
      "menu": "menus",
      "redirects": "old web addresses",
      "announcements": "announcements",
      "texts": "website texts",
      "languages": "website languages",
      "products": "products",
      "collections": "collections",
      "other": "other parts"
    },
    "for_it": "Details for IT",
    "it_tags": "Tags",
    "it_attempts": "Tries",
    "it_answer": "Answer code",
    "it_error": "Error"
  }
}
